export const en = {
    'company-period-time': 'campaign time',
    'days-setting': 'Number of days: {limit}',
    'days-setting-changed': 'Number of days: {oldLimit} {newLimit}',
    'shows-setting': 'Impression limit: {limit}',
    'shows-setting-changed': 'Impression limit: {oldLimit} {newLimit}'
};
